import { render, staticRenderFns } from "./CtaFaceCheckin.vue?vue&type=template&id=1325570a&scoped=true"
import script from "./CtaFaceCheckin.vue?vue&type=script&lang=js"
export * from "./CtaFaceCheckin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325570a",
  null
  
)

export default component.exports